module.exports = __webpack_public_path__ + "img/app-1-on.5fa19a1a.png";